import { DownOutlined } from '@ant-design/icons';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { ColumnTitles } from '../constants/column-titles.constant';
import CustomDropdown from '../../../../v2-components/Antd/Dropdown';

export const dropdownOptionsDelivery = (items) => {
	return (
		<CustomDropdown menu={{ items }} trigger={['click']}>
			<span style={{ cursor: 'pointer' }}>
				{ColumnTitles[Enviroment.LANGUAGE].delivery_type}
				<DownOutlined />
			</span>
		</CustomDropdown>
	);
};
